// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var isV3 = allVue.version && allVue.version[0] === '3';
var inject = allVue.inject;
import { operatorMap, booleanFilterValues, getFilterType } from '../filterCommon';
import { FilterCell } from '../cells/FilterCell';
import { provideLocalizationService } from '@progress/kendo-vue-intl';
import { filterAriaLabel, messages } from '../messages/main';
import { tableKeyboardNavigationTools as navigationTools } from '../navigation/utils';
import { HeaderThElement } from './HeaderThElement';
/**
 * @hidden
 */
var FilterRowVue2 = {
  name: 'kendoFilterRow',
  props: {
    grid: Object,
    columns: Array,
    filter: [Object, Array],
    filterOperators: Object,
    sort: [Object, Array],
    cellRender: [String, Function, Object],
    isRtl: Boolean,
    ariaRowIndex: Number,
    size: String
  },
  inject: {
    kendoLocalizationService: {
      default: null
    }
  },
  methods: {
    headerCellClassName: function headerCellClassName(field, locked) {
      var result = "k-table-th k-header" + (locked ? ' k-grid-header-sticky' : '');
      if (this.$props.sort && this.$props.sort.filter(function (descriptor) {
        return descriptor.field === field;
      }).length > 0) {
        result += ' k-sorted';
      }
      return result;
    },
    setFilter: function setFilter(value, operator, field, e) {
      var filter = this.$props.filter;
      var filters = [];
      if (value !== '' && value !== null || operator !== '') {
        filters.push({
          field: field,
          operator: operator,
          value: value
        });
      }
      if (filter && (filter.filters || filter.length)) {
        var oldFilters = filter.length ? filter : filter.filters || [];
        oldFilters.forEach(function (f) {
          var descriptor = f;
          if (descriptor && descriptor.field !== field) {
            filters.push(descriptor);
          }
        });
      }
      var filtersResult = filters.length > 0 ? {
        logic: 'and',
        filters: filters
      } : null;
      this.$emit('filterchange', filtersResult, e);
    }
  },
  // @ts-ignore
  setup: !isV3 ? undefined : function () {
    var v3 = !!isV3;
    var kendoLocalizationService = inject('kendoLocalizationService', {});
    return {
      v3: v3,
      kendoLocalizationService: kendoLocalizationService
    };
  },
  // @ts-ignore
  render: function render(createElement) {
    var h = gh || createElement;
    var intl = provideLocalizationService(this);
    var oldFilters = this.$props.filter && this.$props.filter.filters ? this.$props.filter.filters : this.$props.filter.length ? this.$props.filter : [];
    var activeFilterValueFor = function activeFilterValueFor(field, defaultValue) {
      if (defaultValue === void 0) {
        defaultValue = null;
      }
      var found = oldFilters.filter(function (filter) {
        return filter.field === field;
      })[0];
      return found ? found.value : defaultValue;
    };
    var activeOperatorFor = function activeOperatorFor(field) {
      var found = oldFilters.filter(function (filter) {
        return filter.field === field;
      })[0];
      return found ? found.operator : null;
    };
    var serviceIndex = 0,
      index = -1;
    var filterCells = this.$props.columns.filter(function (c) {
      return c.children.length === 0;
    }).map(function (column) {
      var _this = this;
      var onChangeFn = function onChangeFn(e) {
        _this.setFilter(e.value, e.operator, column.field, e);
      };
      var filterType = getFilterType(column.filter);
      // @ts-ignore
      var filterRender = h(FilterCell, {
        grid: this.$props.grid,
        attrs: this.v3 ? undefined : {
          grid: this.$props.grid,
          field: column.field,
          size: this.$props.size,
          title: column.filterTitle,
          value: activeFilterValueFor(column.field, filterType === 'text' ? '' : null),
          operator: activeOperatorFor(column.field),
          operators: operatorMap(this.$props.filterOperators[filterType] || [], intl),
          booleanValues: operatorMap(booleanFilterValues, intl),
          filterType: filterType,
          render: column.filterCell || this.$props.cellRender
        },
        field: column.field,
        size: this.$props.size,
        title: column.filterTitle,
        value: activeFilterValueFor(column.field, filterType === 'text' ? '' : null),
        operator: activeOperatorFor(column.field),
        operators: operatorMap(this.$props.filterOperators[filterType] || [], intl),
        booleanValues: operatorMap(booleanFilterValues, intl),
        filterType: filterType,
        onChange: onChangeFn,
        on: this.v3 ? undefined : {
          "change": onChangeFn
        },
        render: column.filterCell || this.$props.cellRender
      });
      var key = column.declarationIndex >= 0 ? ++index : --serviceIndex;
      var ariaAttrs = {
        ariaLabel: column.filterable ? intl.toLanguageString(filterAriaLabel, messages[filterAriaLabel]) : undefined,
        ariaColumnIndex: column.ariaColumnIndex
      };
      var style = column.left !== undefined ? !this.$props.isRtl ? {
        left: column.left + 'px',
        right: column.right + 'px'
      } : {
        left: column.right + 'px',
        right: column.left + 'px'
      } : {};
      var filterCell =
      // @ts-ignore function children
      h(HeaderThElement, {
        key: key,
        columnId: navigationTools.getFilterColumnId(column.id),
        attrs: this.v3 ? undefined : {
          columnId: navigationTools.getFilterColumnId(column.id),
          navigatable: column.navigatable,
          ariaLabel: ariaAttrs.ariaLabel,
          ariaColumnIndex: ariaAttrs.ariaColumnIndex
        },
        navigatable: column.navigatable,
        style: style,
        "class": this.headerCellClassName(column.field, column.locked) || undefined,
        ariaLabel: ariaAttrs.ariaLabel,
        ariaColumnIndex: ariaAttrs.ariaColumnIndex
      }, this.v3 ? function () {
        return [filterRender];
      } : [filterRender]);
      return column.filterable && filterCell ||
      // @ts-ignore function children
      h(HeaderThElement, {
        key: key,
        columnId: navigationTools.getFilterColumnId(column.id),
        attrs: this.v3 ? undefined : {
          columnId: navigationTools.getFilterColumnId(column.id),
          navigatable: column.navigatable,
          ariaLabel: ariaAttrs.ariaLabel,
          ariaColumnIndex: ariaAttrs.ariaColumnIndex
        },
        navigatable: column.navigatable,
        style: style,
        "class": this.headerCellClassName(column.field, column.locked) || undefined,
        ariaLabel: ariaAttrs.ariaLabel,
        ariaColumnIndex: ariaAttrs.ariaColumnIndex
      });
    }, this);
    return h("tr", {
      "class": "k-table-row k-filter-row",
      "aria-rowindex": this.ariaRowIndex,
      attrs: this.v3 ? undefined : {
        "aria-rowindex": this.ariaRowIndex,
        role: 'row'
      },
      role: 'row'
    }, [filterCells]);
  }
};
/**
 * @hidden
 */
var FilterRow = FilterRowVue2;
export { FilterRow, FilterRowVue2 };